import React from 'react';
import Article from '../../components/article/Article';
import { blog01, blog02, blog03, blog04, blog05 } from './imports';
import './blog.css';

const Blog = () => (
  <div className="gpt3__blog section__padding" id="blog">
    <div className="gpt3__blog-heading">
      <h1 className="gradient__text">Featured Articles </h1> 
      <div className="gpt3__features-heading">
      <p>As part of our fiduciary duty, we are selflessly devoted to disseminate knowledge through written words. </p>
      </div>
     
    </div>
    <div className="gpt3__blog-container">
      <div className="gpt3__blog-container_groupA">
      <a href="https://gls.nixque.com/post/fromfailure"> 
      <Article  imgUrl={blog01} date="Oct 18, 2022" text="From Failure to Wins" />
      </a>
        

      </div>
      <div className="gpt3__blog-container_groupB">
        <a href="https://gls.nixque.com/post/exploration">
        <Article  imgUrl={blog02} date="Nov 13, 2022" text="On Higher Education" />
        </a>
        
        <a href="https://gls.nixque.com/post/mayday">
        <Article  imgUrl={blog03} date="Nov 03, 2022" text="Economic Shutdown" />
        </a>

        <a href="https://gls.nixque.com/post/missingher">
        <Article  imgUrl={blog05} date="Oct 06, 2022" text="Zooming-in the Past" />
        </a>

        <a href="https://gls.nixque.com/post/actionspeaks">
        <Article  imgUrl={blog04} date="Nov 01, 2022" text="Signing to Practicality" />
        </a>
      </div> 
    </div>
  </div>
);

export default Blog;